<div class="app-reporting-period-table">
   <p-table
      class="w-full"
      [value]="reportingPeriodsArray ?? []"
      tableStyleClass="w-full"
      [tableStyle]="{ width: '100%', 'min-width': '100%' }"
      [scrollable]="true"
      [scrollHeight]="height"
   >
      <ng-template pTemplate="headergrouped">
         <tr>
            <th [rowSpan]="2">{{ 'reporting_periods' | translate }}</th>
            <th [colSpan]="2">{{ 'duration' | translate }}</th>
            <th [colSpan]="2">{{ 'dates' | translate }}</th>
            @if (!readonly) {
               <th
                  [rowSpan]="2"
                  class="w-[60px] !bg-white !border-0 action-cell"
               ></th>
            }
         </tr>
         <tr>
            <th>{{ 'start_month' | translate }}</th>
            <th>{{ 'end_month' | translate }}</th>
            <th>{{ 'start_date' | translate }}</th>
            <th>{{ 'end_date' | translate }}</th>
         </tr>
      </ng-template>
      <ng-template
         pTemplate="body"
         let-item
         let-rowIndex="rowIndex"
      >
         <tr>
            <td>{{ item.periodName ?? '-' }}</td>
            <td>{{ item.startMonth ?? '-' }}</td>
            <td>{{ item.endMonth ?? '-' }}</td>
            <td>{{ item?.startDate ? (item?.startDate | date: 'dd/MM/YYYY') : '-' }}</td>
            <td>{{ item?.endDate ? (item?.endDate | date: 'dd/MM/YYYY') : '-' }}</td>
            @if (!readonly) {
               <td class="w-[60px] !bg-white !border-0 action-cell">
                  @if (rowIndex == (reportingPeriodsArray?.length ?? 0) - 1) {
                     <span
                        class="w-[28px] h-[28px] fill-app-primary-2 pointer-events-auto cursor-pointer hover:opacity-50 flex items-center"
                        [inlineSVG]="'/assets/icons/delete.svg'"
                        (click)="deleteReportClick.emit()"
                     ></span>
                  }
               </td>
            }
         </tr>
      </ng-template>
   </p-table>
</div>
